import "Common.css";
import "../PricingEngineSummary.css";

import React from "react";
import BaseElem from "BaseElem";

type PricingEngineVisitBreakdownItemProps = {
  _id: string;
  name?: string;
  type?: string;
  price?: string | number;
  descriptions?: Array<string>;
  isNegative?: boolean;
  waived?: boolean;
};

type PricingEngineVisitBreakdownItemState = {};

class PricingEngineVisitBreakdownItem extends BaseElem<
  PricingEngineVisitBreakdownItemProps,
  PricingEngineVisitBreakdownItemState
> {
  render() {
    const props = this.props;

    const isNegativeNumber = props.waived || props.isNegative;
    return (
      <div
        className="v pes-price-breakdown-container"
        key={`pricing-${props._id}-${props.type}`}
      >
        <div className="h justified">
          <p className="pes-visit-schedule-duration">
            {isNegativeNumber && <b>Less&nbsp;</b>}
            {props.name}
          </p>
          <p className="pes-visit-price-breakdown">
            {/* {isNegativeNumber ? `(${props.price})` : `${props.price}`} */}
            {props.price}
          </p>
        </div>
        {(props.descriptions || []).map(
          (description: string, index: number) => (
            <div
              className="pes-visit-pricing-subtitle"
              key={`pricing-description-${props._id}-${index}`}
            >
              {description}
            </div>
          )
        )}
      </div>
    );
  }
}

export default PricingEngineVisitBreakdownItem;
